import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import Parser from 'html-react-parser';

// components
import { Row, Col, Card, CardBody, Button, Spinner } from "reactstrap";
import { useReactToPrint } from 'react-to-print';
import { LogotipoBlack, LogoMarca } from "constants/Logotipo";
import PrintFooter from '../../components/PrintFooter/PrintFooter';

// Views
import Identificacao from "./BoletimVistoriaComponents/Identificacao";
import BoletinsVinculados from './BoletimVistoriaComponents/BoletinsVinculados';
import Cabecalho from "./BoletimVistoriaComponents/Cabecalho";
import InspecoesImpressao from './BoletimVistoriaComponents/InspecoesImpressao';
import HistoricoAnalise from './BoletimVistoriaComponents/HistoricoAnalise';
import PenalidadesAplicadas from './BoletimVistoriaComponents/PenalidadesAplicadas';

// api
import boletimvistoria_api from "../../api/boletimvistoria_api.js";
import setup_api from "../../api/setup_api.js";

export default function VistoriaFichaImpressao({ history }) {

    const [boletimVistoria, set_boletimVistoria] = useState(null);
    const [setup, set_setup] = React.useState(null);

    const loadBoletimVistoria = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);

        setup_api.get().then(result => {
            if (result.status === 200) {
                set_setup(result.data);
            }
        });

        boletimvistoria_api.getItem(params.codigo).then(result => {
            if (result.status === 200) {
                set_boletimVistoria(result.data);
            }
        });
    }

    useEffect(() => {
        loadBoletimVistoria();
    }, []);

    const componentRef = React.useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true
    });

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12" className="text-center">
                        <Button color="danger" onClick={handlePrint}><i className="fas fa-print"></i>  Imprimir</Button>
                    </Col>
                </Row>
                <Card>
                    <CardBody>
                        {boletimVistoria &&
                            <ComponentToPrint boletimVistoria={boletimVistoria} ref={componentRef} setup={setup} />
                        }
                        {!boletimVistoria &&
                            <div className="carregandoCmp">
                                <div className="box">
                                    <Spinner></Spinner>
                                </div>
                            </div>
                        }
                    </CardBody>
                </Card>
            </div>
        </>
    );
}

export const ComponentToPrint = React.forwardRef((props, ref) => {
    const boletimVistoria = props.boletimVistoria;
    const setup = props.setup;

    return (
        <div ref={ref}>
            <div className="row d-flex justify-content-center align-items-center">
                <div className="col-2 text-center">
                    <img src={LogotipoBlack()} width="150"></img>
                </div>
                <div className="col-8 text-center">
                    {Parser(setup.cabecalhoDocumentos)}
                </div>
                <div className="col-2">
                    <img src={LogoMarca()} width="150"></img>
                </div>
            </div>
            <h4 className="titleCard font-weight-bold text-center">{boletimVistoria.formularioVistoria_Identificacao}</h4>
            <Identificacao
                boletimVistoria={boletimVistoria}
            />
            {boletimVistoria.boletimVistoriaVinculos.length > 0 && <BoletinsVinculados
                boletimVistoriaVinculos={boletimVistoria.boletimVistoriaVinculos} />
            }
            <Cabecalho
                boletimVistoria={boletimVistoria}
            />
            <InspecoesImpressao
                boletimVistoria={boletimVistoria}
            />
            {boletimVistoria.boletimVistoriaPenalidades.length > 0 && <PenalidadesAplicadas
                penalidades={boletimVistoria.boletimVistoriaPenalidades}
            />
            }
            {boletimVistoria.boletimVistoriaHistoricoAnalise.length > 0 && <HistoricoAnalise
                historico={boletimVistoria.boletimVistoriaHistoricoAnalise}
            />
            }
            <PrintFooter />
        </div>
    )
})
